import { openContactScheduling, openEmailContact } from '@/utils/mail';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CtaCard } from './cta-card';
import { View } from './ui/tw-wrappers';

export function Contact() {
  const { t } = useTranslation();
  const handleSchedulePress = () => {
    openContactScheduling();
  };
  return (
    <View className='flex-1 flex-col md:flex-row gap-4 md:h-full'>
      <CtaCard
        iconName='calendar'
        iconSize={24}
        title={t('cta.schedule.title')}
        description={t('cta.schedule.description')}
        buttonLabel={t('cta.schedule.button')}
        onButtonPress={handleSchedulePress}
      />
      <CtaCard
        iconName='mail.fill'
        iconSize={24}
        title={t('cta.contact.title')}
        description={t('cta.contact.description')}
        comment={t('cta.contact.comment')}
        buttonLabel={t('cta.contact.button')}
        onButtonPress={openEmailContact}
      />
    </View>
  );
}
